export default {
    titles: {
        home: '首页',
        service: '产业服务',
        datacenter: '数据中心',
        about: '关于我们',
        // contactUs: '联系我们',
        // lange: '英文'
    }
}